import React, {useRef, useState, useEffect} from 'react';
import {connect} from 'react-redux'
import {Link, useRouteMatch} from 'react-router-dom'
import {Animate} from 'react-move'
import { easeExpInOut, easeExpIn } from 'd3-ease'
import VisibilitySensor from 'react-visibility-sensor'

import LazyImageComponent from './../LazyImageComponent'
import LinkWrapper from './../LinkWrapper'

function Thumb({data, dataKey, scrollPosition, dispatch, screenSize, isMobileSize, isMobile, blind}) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [hasBeenInViewport, setHasBeenInViewport] = useState(false);

    const singlePeopleMatch = useRouteMatch("/people/:name");
    let personIsInFocus = singlePeopleMatch ? singlePeopleMatch.params.name === data.slug ? true : false : false
    // console.log(dataKey);

    const thumbRef = useRef();
    const videoRef = useRef();
    const imageRef = useRef();

    const getThumbOffsetY = () => {
        if (thumbRef.current) {
            const {offsetTop} = thumbRef.current;
            const {offsetHeight} = imageRef.current;
            const currentCenterPosition = offsetTop + offsetHeight/2;
            const newCenterPosition = scrollPosition + screenSize.height/2
            const calculatedOffset = newCenterPosition - currentCenterPosition;
            return calculatedOffset
        }
    }

    const getThumbOffsetX = () => {
        if (thumbRef.current) {
            const {offsetLeft, offsetWidth} = thumbRef.current;
            const currentCenterPosition = offsetLeft + offsetWidth/2;
            const newCenterPosition = (screenSize.width - 33)/4
            const calculatedOffset = newCenterPosition - currentCenterPosition;
            return calculatedOffset
        }
    }

    useEffect(() => {
        if (personIsInFocus) {
            playVideo();

            setTimeout(() => {
                const {offsetHeight} = imageRef.current;
                const newTopPosition = screenSize.height/2 - offsetHeight * 1.3 / 2 

                dispatch({
                    type: 'SET_SINGLE_PERSON_THUMB_OFFSET_TOP',
                    offset: newTopPosition
                })

            }, 200)
        } else {
            pauseVideo();
        }
    }, [personIsInFocus])

    const animationConfig = {
        dekstop: {
            start: {
                xOffset: isMobileSize ? 0 : personIsInFocus ? [getThumbOffsetX()] : [0], 
                yOffset: isMobileSize ? 0 : personIsInFocus ? [getThumbOffsetY()] : [0],
                textOpacity: personIsInFocus ? [0] : [1],
                scale: isMobileSize ? 1 : personIsInFocus ? [1.3] : [1],
                zIndex: isMobileSize ? 1 : personIsInFocus ? 100 : [1],
                timing: {delay: isMobileSize ? 0 : personIsInFocus ? 0 : 150, duration: personIsInFocus ? 0 : 600, ease: easeExpInOut}
            },
            update: [{
                    xOffset: isMobileSize ? 0 : personIsInFocus ? [getThumbOffsetX()] : [0], 
                    yOffset: isMobileSize ? 0 : personIsInFocus ? [getThumbOffsetY()] : [0],
                    scale: isMobileSize ? 1 : personIsInFocus ? [1.3] : [1],
                    timing: {delay: isMobileSize ? 0 : personIsInFocus ? 0 : 50, duration: 600, ease: easeExpInOut}
                }, {
                    zIndex: isMobileSize ? 1 : personIsInFocus ? 100 : [1],
                    timing: {delay: isMobileSize ? 0 : personIsInFocus ? 0 : 900}
                }, {
                    textOpacity: personIsInFocus ? [0] : [1],
                    timing: {delay: personIsInFocus ? 0 : 400, duration: 300}
                }]   
        }
    }

    const playVideo = () => {
        if (!isMobile) videoRef.current.play()
    }

    const pauseVideo = () => {
        if (!isMobile) videoRef.current.pause()
    }

	return(
        <VisibilitySensor partialVisibility={true} active={hasBeenInViewport ? false : true} onChange={(isVisible) => {setIsVisible(isVisible); if (isVisible) setHasBeenInViewport(true)}}>
    		<div className="col col4 col8-s portrait-thumb">
                {/*<ScrollVisibilityComponent>*/}
                    <LinkWrapper>
                        <Link to={`/people/${data.slug}`}>
                                <Animate
                                    start={animationConfig.dekstop.start}
                                    update={animationConfig.dekstop.update}
                                >
                                {({xOffset, yOffset, scale, zIndex, textOpacity}) => {
                                    // console.log(zIndex);
                                    return(
                                        <div className={`inner viewport-visibility-component ${isVisible || personIsInFocus ? 'visible' : 'hidden'}`} ref={thumbRef} style={{zIndex: zIndex, pointerEvents: personIsInFocus ? 'none' : 'auto'}}>
                                            <div ref={imageRef} className="lazy-image-component" style={{transform: `translateX(${xOffset}px) translateY(${yOffset}px) scale(${scale})`, paddingBottom: '141.667%'}}>
                                                <video ref={videoRef} className={`people-video ${isLoaded ? 'loaded' : 'lazy-loading'}`} muted loop onCanPlay={() => setIsLoaded(true)} onMouseEnter={() => personIsInFocus ? null : playVideo()} onMouseLeave={() => personIsInFocus ? null : pauseVideo()}>
                                                    <source src={`${data.video}#t=0.1`} type="video/mp4"/>
                                                </video>
                                            </div>
                                            <div className="name" style={{opacity: textOpacity}}>{data.title}</div>
                                            <ul className="data" style={{opacity: textOpacity}}>
                                                {data.profession ? <li>{data.profession}</li> : null}
                                                {data.work_title ? <li>{data.work_title}</li> : null}
                                                {data.phone ? <li>{data.phone}</li> : null}
                                                {data.email ? <li>{data.email}</li> : null}
                                            </ul>
                                        </div>
                                        )
                                    }
                                }
                                </Animate>
                        </Link>
                    </LinkWrapper>

                {/*</ScrollVisibilityComponent>*/}
            </div>
        </VisibilitySensor> 
		)
}

export default connect((state) => ({
    scrollPosition: state.App.scrollPosition,
    screenSize: state.Device.size,
    isMobileSize: state.Device.isMobileSize,
    isMobile: state.Device.isMobile
}))(Thumb)